import type { TripType } from "../use-flight-search-form";
import type { Route, useForm } from "../../use-form";

const roundTripHasErrors = (route: Route) =>
  !route.origin ||
  !route.destination ||
  !route.departureDate ||
  !route.returnDate;

const oneWayHasErrors = (route: Route) =>
  !route.origin || !route.destination || !route.departureDate;

export const flightSearchFormHasErrors = ({
  formList,
  tripType,
}: {
  formList: ReturnType<typeof useForm>;
  tripType: TripType;
}) => {
  switch (tripType) {
    case "round-trip": {
      return roundTripHasErrors(formList.first);
    }
    case "one-way": {
      return oneWayHasErrors(formList.first);
    }
    case "multi-city": {
      return formList.routes.some((route) => oneWayHasErrors(route));
    }
    default: {
      return false;
    }
  }
};
